<div #payeeSwitcherGroup class="wrapper flex">
  <ng-content select="button[payee-switcher-button]"></ng-content>
</div>